import { app } from '../../../../../../../bootstrap/core';

import { dispatchAddressComponent } from './dispatchAddress.component';

app.component(dispatchAddressComponent.name, dispatchAddressComponent);
